import { render, staticRenderFns } from "./OnboardingTokenExchange.vue?vue&type=template&id=2cb53885&scoped=true&lang=pug"
import script from "./OnboardingTokenExchange.vue?vue&type=script&lang=ts"
export * from "./OnboardingTokenExchange.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingTokenExchange.vue?vue&type=style&index=0&id=2cb53885&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb53885",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
